export default __webpack_public_path__ + "static/pomoTimerApp-60f659b562abbe097217a3050166dc6b.png";